import { HoldingsDatePickerDirective } from 'SecuritiesApp/ts/directives/holdings-date-picker.directive';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
import * as i3 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
const _c0 = a0 => ({ "disabled": a0 });
const _c1 = () => ({ button: "btn btn-secondary dropdown-toggle" });
const _c2 = () => ({ button: "btn btn-secondary dropdown-toggle", dropdownContainer: "-ml-1" });
/**
 * HoldingsAllHoldingsDatePickerComponent
 *
 * This component allows the user to select a MM/YY date. (Only month and year, no specific day, can be selected).
 * Only a specified set of dates will be shown for the user to select. This is useful
 * in cases where we want to restrict selection to a small of valid date options. This component also allows
 * the user to navigate to the next and previous valid date options with arrow buttons
 *
 * Input Properties:
 *   dateOptions: list of date options in string format for the date picker to display for selection
 *
 * Output Properties:
 *   dateChangeHandler: Emits the newly selected year and month whenever a new date is selected
 */
export class HoldingsAllHoldingsDatePickerComponent extends HoldingsDatePickerDirective {
}
HoldingsAllHoldingsDatePickerComponent.ɵfac = /*@__PURE__*/ (() => { let ɵHoldingsAllHoldingsDatePickerComponent_BaseFactory; return function HoldingsAllHoldingsDatePickerComponent_Factory(__ngFactoryType__) { return (ɵHoldingsAllHoldingsDatePickerComponent_BaseFactory || (ɵHoldingsAllHoldingsDatePickerComponent_BaseFactory = i0.ɵɵgetInheritedFactory(HoldingsAllHoldingsDatePickerComponent)))(__ngFactoryType__ || HoldingsAllHoldingsDatePickerComponent); }; })();
HoldingsAllHoldingsDatePickerComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HoldingsAllHoldingsDatePickerComponent, selectors: [["ycn-holdings-all-holdings-date-picker"]], standalone: false, features: [i0.ɵɵInheritDefinitionFeature], decls: 8, vars: 16, consts: [[1, "btn-group", "ml-4"], ["data-test-id", "Prev Button", 1, "btn", "btn-secondary", 3, "click", "ngClass"], ["ycnIcon", "", 3, "name"], [1, "btn-group"], ["data-test-id", "Month Dropdown", 3, "changeHandler", "customCssClasses", "selectedValue", "config"], ["data-test-id", "Year Dropdown", 3, "changeHandler", "customCssClasses", "selectedValue", "config"], ["data-test-id", "Next Button", 1, "btn", "btn-secondary", 3, "click", "ngClass"]], template: function HoldingsAllHoldingsDatePickerComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
        i0.ɵɵlistener("click", function HoldingsAllHoldingsDatePickerComponent_Template_button_click_1_listener() { return ctx.prevDate(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(2, "svg", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(3, "div", 3)(4, "ycn-single-select-dropdown", 4);
        i0.ɵɵlistener("changeHandler", function HoldingsAllHoldingsDatePickerComponent_Template_ycn_single_select_dropdown_changeHandler_4_listener($event) { return ctx.selectMonthHandler($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "ycn-single-select-dropdown", 5);
        i0.ɵɵlistener("changeHandler", function HoldingsAllHoldingsDatePickerComponent_Template_ycn_single_select_dropdown_changeHandler_5_listener($event) { return ctx.selectYearHandler($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "button", 6);
        i0.ɵɵlistener("click", function HoldingsAllHoldingsDatePickerComponent_Template_button_click_6_listener() { return ctx.nextDate(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(7, "svg", 2);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(10, _c0, ctx.disablePrev));
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-back");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(12, _c1))("selectedValue", ctx.selectedMonth)("config", ctx.monthDropdownConfig);
        i0.ɵɵadvance();
        i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(13, _c2))("selectedValue", ctx.selectedYear)("config", ctx.yearDropdownConfig);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c0, ctx.disableNext));
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-collapse");
    } }, dependencies: [i1.NgClass, i2.SingleSelectDropdownComponent, i3.IconDirective], encapsulation: 2 });
